export default __webpack_public_path__ + "static/media/quicksteps.f474d573.png";